import React from 'react';
import { sliceString } from '../../../helpers/node';
import { useBaseStyles } from '../style';

function Header(props) {
  const {
    width, title, color, icon, dndEvents,
  } = props;

  const styles = useBaseStyles();

  return (
    <foreignObject
      x={1}
      y={1}
      width={width - 2}
      height={30}
      {...dndEvents}
    >
      <div
        className={styles.title}
        style={{ backgroundColor: color }}
      >
        <img
          draggable={false}
          className="icon"
          src={icon}
          alt="node icon"
        />
        <span className="text">
          {title && sliceString(title, 22)}
        </span>
      </div>
    </foreignObject>
  );
}

export default Header;
